import { AtRiskStatus } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { AxisGroup } from '@frontend/charts';
import { i18next } from '@frontend/i18n';

export const APPOINTMENT_NO_SHOW_RISK_OPTIONS = [
  {
    label: i18next.t('Repeat cancel', { ns: 'analytics' }),
    value: AtRiskStatus.AT_RISK_STATUS_REPEAT_CANCEL,
  },
  {
    label: i18next.t('Repeat no-show', { ns: 'analytics' }),
    value: AtRiskStatus.AT_RISK_STATUS_REPEAT_NSR,
  },
];

export const APPOINTMENT_NO_SHOW_RISK_Y_AXIS_GROUPS: AxisGroup[] = [
  {
    label: i18next.t('No-Show Risk Status', { ns: 'analytics' }),
    key: 'atRiskStatus',
    icon: 'alert',
    selectionType: 'checkbox',
    options: APPOINTMENT_NO_SHOW_RISK_OPTIONS,
  },
];
